import '../styles/SpendingTimeline.css';

import React, {useEffect, useState} from 'react';
import { Group } from '@visx/group';
import { scaleOrdinal } from '@visx/scale';
import { LegendOrdinal } from '@visx/legend';
import {useSearchParams} from "react-router-dom";
import useAxiosRequest from "../hooks/useAxiosRequest";
import config from "../config.json";
import { Pie } from "@visx/shape";

const SpendingBarChart = () => {
    const [ searchParams ] = useSearchParams();

    const { data, isLoading } = useAxiosRequest({
        url: `${config.backendUrl}/charts/data?id=${searchParams.get("data")}`,
        withCredentials: true,
        method: "get"
    });

    const [ pieChartData, setPieChartData ] = useState(null);

    const [ colorScale, setColorScale ] = useState(null);

    const [ isProcessing, setProcessing ] = useState(true);

    useEffect(() => {
        if (!data) return;

        data.parties.sort((a, b) => {
            const totalA = data.events.filter(event => event.party === a.code).reduce((sum, event) => sum + event.spent, 0);
            const totalB = data.events.filter(event => event.party === b.code).reduce((sum, event) => sum + event.spent, 0);

            return totalB - totalA;
        })

        const pieChartData = data.parties.map(party => ({ party: party.code, spent: data.events.filter(event => event.party === party.code).reduce((sum, event) => sum + event.spent, 0) }));

        setPieChartData(pieChartData);

        const colorScale = scaleOrdinal({
            domain: data.parties.filter(party => data.events.find(event => event.party === party.code)).map(party => party.code),
            range: data.parties.filter(party => data.events.find(event => event.party === party.code)).map(party => party.color)
        });

        setColorScale([colorScale]);

        setProcessing(false);
    }, [data]);

    if (isProcessing) return;

    return (
        <div id={"chart"} style={{ width: "800px", height: "400px", position: "absolute" }}>
            <div style={{ zIndex: 10, position: "absolute", left: "500px", height: "400px", display: "flex", alignItems: "center", fontWeight: "500", fontSize: "16px" }}>
                <LegendOrdinal
                    scale={colorScale[0]}
                    labelFormat={(code) => {
                        const party = data.parties.find(party => party.code === code);
                        return (party?.shortName || party?.name || code) + ": $" + pieChartData.find(other => other.party === party.code).spent.toLocaleString();
                    }}
                    direction="column"
                    itemMargin={"5px"}
                />
            </div>
            <svg width={800} height={400} style={{ position: "absolute", top: "0px", left: "50px" }}>
                <rect
                    x={0}
                    y={0}
                    width={800}
                    height={400}
                    fill="white"
                />
                <Group left={250} top={200}>
                    <Pie
                        data={pieChartData}
                        pieValue={(d) => d.spent}
                        pieSortValues={(a, b) => b - a}
                        outerRadius={150}
                        innerRadius={50}>
                        {(pie) => {
                            return pie.arcs.map((arc, index) => {
                                const { party } = arc.data;
                                const arcPath = pie.path(arc);
                                const arcFill = colorScale[0](party);
                                return <path key={`arc-${party}-${index}`} d={arcPath} fill={arcFill} />;
                            });
                        }}
                    </Pie>
                </Group>
            </svg>
        </div>
    );
}

export default SpendingBarChart;
